<script>

    import Navigation from "./Navigation.svelte";
    import Button from "./Button.svelte";

    import Icon from './Icon.svelte';
    import { _ } from 'svelte-i18n';

    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';

    let { onAccept = () => {}, onDecline = () => {} } = $props();

    let dialog;

    function openDialog() {
        if (typeof dialog?.showModal === 'function') {
            dialog.showModal();
        } else if (dialog) {
            dialog.setAttribute('open', '');
        }
    }

    function closeDialog() {
        if (typeof dialog?.close === 'function') {
            dialog.close();
        } else if (dialog) {
            dialog.removeAttribute('open');
        }
    }

    export function show() {
        openDialog();
    }

    function handleAccept() {
        closeDialog();
        onAccept();
    }

    function handleDecline() {
        closeDialog();
        onDecline();
    }

</script>

<dialog bind:this={dialog} aria-labelledby="cookie-dialog-title">
    <h3 id="cookie-dialog-title">{$_('cookie_banner_title')}</h3>
    <p>
        {@html $_('cookie_banner_description_p1')}
    </p>
    <p>
        {@html $_('cookie_banner_description_p2')}
    </p>

    <Navigation>
        <Button onclick={handleDecline}>
            {$_('cookie_banner_decline')}
            <Icon data={arrowRightIcon} />
        </Button>

        <Button color="accent" autofocus={true} onclick={handleAccept}>
            {$_('cookie_banner_accept')}
            <Icon data={arrowRightIcon} />
        </Button>
    </Navigation>
</dialog>


<style>

    dialog {
        border: none;
        border-radius: var(--card-radius);
        padding: 2em;
        max-width: 36em;

        background: #fff;
        color: #000;
        box-shadow: 0 0 20px rgba(0,0,0,.15),0 20px 40px rgba(0,0,0,.05);
    }

    @media (prefers-color-scheme: dark) {
        dialog {
            background: #333;
            color: #fff;
            box-shadow: 0 0 20px rgba(0,0,0,.5), 0 20px 40px rgba(0,0,0,.3);
        }
    }

    @media (max-width: 600px) {
        dialog {
            margin-left: 1em;
            margin-right: 1em;
        }
    }

    :global(::backdrop) {
        background: rgba(0, 0, 0, 0.4);
    }

    @media (prefers-color-scheme: dark) {
        :global(::backdrop) {
            background: rgba(0, 0, 0, 0.6);
        }
    }

    h3 {
        font-family: var(--theme-alt-font-family);
        font-weight: var(--theme-font-weight);
        font-size: 2em;
        margin: 0;
    }

    p {
        font-size: 0.95em;
    }

    p :global(a) {
        text-decoration: underline;
        color: inherit;
    }

</style>

